import { PropOptionSelect } from '@/models'
import { FiltersAssistance } from '@/models/assistance'

const TYPE_MARKING_ENTRY = 1
const TYPE_MARKING_EXIT = 2

const OPTIONS_TYPES_MARKING: PropOptionSelect[] = [
    {
        text: 'INGRESO',
        value: TYPE_MARKING_ENTRY
    },
    {
        text: 'SALIDA',
        value: TYPE_MARKING_EXIT
    }
]

const FILTERS_ASSISTANCE_DEFAULT: FiltersAssistance = {
    dateEnd: null,
    dateStart: null,
    employeeId: null,
    headquartersId: null,
    areaId: null,
    subareaId: null
}

export {
    TYPE_MARKING_EXIT,
    TYPE_MARKING_ENTRY,
    OPTIONS_TYPES_MARKING,
    FILTERS_ASSISTANCE_DEFAULT
}
